import { observer } from 'mobx-react';
import { summaryStore } from '../store';
import styles from './index.module.scss';
import { Button, Modal, Table } from 'antd';

const UltraDialogTableColumns = [
    {
        title: 'NORMAL',
        key: 'normal',
        dataIndex: 'normal',
        width: '50%',
        render: (t) => <div className={styles.normalText}>{t}</div>,
    },
    {
        title: <div className={styles.ultraColumn}>ULTRA</div>,
        key: 'ultra',
        dataIndex: 'ultra',
        width: '50%',
        render: (t) => <div className={styles.ultraText}>{t}</div>,
    },
];

export const UltraDialog = observer(() => {
    return (
        <Modal
            title="灵感风暴 NORMAL VS ULTRA"
            open={summaryStore.showUltraDialog}
            width={600}
            className={styles.ultraDialog}
            maskClosable
            onCancel={() => summaryStore.toggleUltraDialog()}
            footer={
                <Button
                    type="primary"
                    style={{ background: '#f7941d' }}
                    onClick={() => {
                        if (!summaryStore.useUltra) {
                            summaryStore.toggleUseUltra();
                        }
                        summaryStore.hideUltraDialog();
                    }}
                >
                    使用 ULTRA 版本
                </Button>
            }
        >
            <div className={styles.title}>ULTRA版优势</div>
            <div className={styles.highlight}>
                <p>
                    <b>更专业：</b>
                    模型在使用专业术语方面进行了针对性强化，提升了写作的专业水平。
                </p>
                <p>
                    <b>更聪明：</b>
                    全面扩展了对多学科领域的学习，增强了在多种学术场景中的知识储备。
                </p>
                <p>
                    <b>更流畅：</b>
                    经过大量学术文章的学习优化，写作风格变得更灵活更流畅。
                </p>
            </div>
            <div className={styles.title}>详细对比</div>
            <div className={styles.item}>
                <i>1</i>
                <div className={styles.desc}>更专业</div>
                <b>对比段落:</b>
                <div className={styles.detail}>【概述恋爱的定义】</div>
            </div>
            <Table
                pagination={false}
                columns={UltraDialogTableColumns}
                dataSource={[
                    {
                        key: '1',
                        normal: '恋爱是一种情感状态，通常是指两个人之间存在着深厚的感情联系和亲密的关系。它不仅包括浪漫和激情的成分，也涵盖了关怀、理解、支持和信任等元素。恋爱中的两个人会彼此吸引，分享共同的兴趣和经历，并愿意为对方付出时间和精力。恋爱可以带来幸福感、快乐以及对未来的期待，但也可能伴随着挑战和冲突的解决。每个人的恋爱体验都是独特的，它可以是短期的激情，也可以是长期的承诺和伴侣关系。',
                        ultra: '恋爱是一种复杂而深刻的人际情感联系，主要发生在两个个体之间，通常指男女之间的浪漫关系，尽管现代社会对恋爱的理解也包括了同性间的爱情。以下是对恋爱定义的综合概述：\n情感纽带：恋爱首先表现为一种强烈的情感纽带，它源于双方对彼此的深深喜爱、欣赏与依恋。这种感情通常是自发且真诚的，包含对对方人格特质、外貌、才智、价值观等各方面的高度认同与吸引力。\n心理互动：恋爱不仅仅是单方面的感情投射，而是双方在情感上的相互回应与互动。双方通过沟通、理解、支持与共情，建立起深厚的心理联结，共享快乐、分担忧虑，形成独特的心理空间。\n理想寄托：恋爱往往伴随着对未来生活的共同设想与期待，即所谓“共同的人生理想”。恋爱双方可能设想共同建立家庭、规划职业发展、旅行或实现其他生活目标，这些理想构成了恋爱关系的重要基础，也是双方愿意持续投入并深化关系的动力。\n生理反应：恋爱期间，人体内分泌系统会发生显著变化，释放一系列神经递质和激素，如多巴胺、苯基乙胺、血清素（5-羟色胺）、去甲肾上腺素等，这些被称为“恋爱化学物质”，它们引发兴奋、愉悦、紧张、渴望等情绪体验，强化恋人之间的亲密感和吸引力。\n行为表现：恋爱不仅是一种内在情感状态，还体现在外在的行为模式上。这包括但不限于频繁的交流与互动、身体接触（如牵手、拥抱、亲吻）、互赠礼物、共享活动、公开表达爱意、为对方着想和牺牲个人利益等。\n承诺意愿：恋爱往往伴随着对长期关系的期待和承诺，即渴望对方成为自己的终生伴侣。这种承诺不仅体现在口头表达上，更体现在日常生活中对关系的维护、问题的解决以及面对困难时的坚守。\n社会文化背景：恋爱定义受到特定社会文化环境的影响，其表现形式、期待值、交往规则等会随时代变迁、地域差异、个人观念等因素有所不同。在某些文化中，恋爱可能还涉及家庭、社群的认可和支持，以及遵循特定的社会规范和仪式。\n综上所述，恋爱是一个涵盖情感、心理、生理、行为、理想、承诺和社会文化等多个层面的综合性现象，是两个个体间基于相互吸引、深厚情感、共同理想和未来承诺而形成的亲密关系。',
                    },
                ]}
            />
            <div className={styles.item}>
                <i>2</i>
                <div className={styles.desc}>更聪明</div>
                <b>对比段落:</b>
                <div className={styles.detail}>【概述恋爱期间财产给与的定性及处理】</div>
            </div>
            <Table
                pagination={false}
                columns={UltraDialogTableColumns}
                dataSource={[
                    {
                        key: '1',
                        normal: '恋爱期间的财产给与，从法律角度来看，其性质和处理方式通常取决于财产的性质、给与的目的以及双方的约定。以下是一些常见的情况：\n礼物性质：如果一方出于爱意或其他情感原因给予另一方财物，且没有明确的预期回报，这通常被视为个人礼物，一般不需要返还。然而，如果金额巨大或涉及到房产等重大财产，可能需要考虑当地的赠与税法规。\n共同生活支出：如果财物用于双方共同的生活开销，比如房租、餐饮等，那么这些支出通常被视为双方的共同责任，分手后不易追溯。\n有条件给与：如果财物给与时带有某种条件，如结婚、生子等，那么在未满足条件的情况下，可能会有要求返还的法律依据，但这需要具体的合同或证据支持。\n借贷性质：如果财物给与是基于借款的意图，且有书面证据，那么在分手后，出借方有权要求对方偿还。\n欺诈或强迫行为：如果财物给与是在欺诈或强迫情况下发生的，那么法律可能会支持受害方的权益，要求返还财产。\n总的来说，处理恋爱期间的财产问题，最重要的是双方的沟通和约定。为了避免未来的纠纷，最好在涉及重大财产转移时，能有书面协议明确各方的权利和义务。如果出现争议，可能需要寻求法律专业人士的帮助。\n',
                        ultra: '在恋爱期间，双方可能会涉及财产的交换或赠与行为，这些行为的定性和处理主要受到民法典等相关法律法规的约束。以下是对恋爱期间财产给与的定性及处理的一般概述：\n自愿赠与：恋爱期间，一方主动给予另一方财物，如礼物、金钱、支付生活费用等，通常被视为自愿赠与行为。赠与基于双方的情感关系，而非法律上的义务。根据《中华人民共和国民法典》的规定，赠与合同是赠与人将自己的财产无偿给予受赠人，受赠人表示接受赠与的合同。一旦赠与物交付完成，且不存在法定撤销情形，赠与即生效，受赠人享有该财产的所有权。\n赠与性质的确定：判断是否为赠与的关键在于双方是否存在赠与的合意以及赠与物是否实际交付。如果赠与时明确表示是作为礼物或无条件赠予，或者在日常交往中以示爱意、庆祝节日等方式赠送，一般会被认定为赠与。另外，若赠与物价值较大，建议以书面形式明确赠与意图，避免日后产生争议。\n赠与撤销：根据《民法典》规定，赠与人在赠与财产的权利转移之前可以撤销赠与。但在恋爱关系中，撤销赠与的情况相对复杂，常见的法定撤销情形包括：\n受赠人严重侵害赠与人或者赠与人的近亲属的合法权益；\n受赠人对赠与人有扶养义务而不履行；\n受赠人不履行赠与合同约定的义务。\n如果赠与物已交付但符合法定撤销情形，赠与人可在知道或者应当知道撤销事由之日起一年内行使撤销权。此外，对于具有道德义务性质的赠与，如以结婚为目的的大额赠与，若婚姻关系未能缔结，赠与人有权请求返还。\n特殊情形下的财产处理：在某些特殊情况下，恋爱期间的财产给与可能不被认定为赠与，而是视为共有财产、借款或其他性质的经济往来，例如：\n共有财产：双方共同出资购买并用于共同生活的物品，如家具家电、车辆等，如果没有明确约定，则可能被视为共有财产，分手时应按出资比例或公平原则进行分割。\n借款：一方明确表示给对方的款项为借款，并有借条、转账记录等证据支持，那么即使处于恋爱关系中，也应按照借贷关系处理，借款人负有偿还义务。\n其他经济往来：如一方为对方支付学费、房租等，可视具体情况判断是否构成债权债务关系，如有明确约定或能证明存在偿还意图，可能需要对方返还。\n举证责任：在恋爱期间财产纠纷的诉讼中，主张返还的一方通常需要承担举证责任，提供证据证明给与的性质（如赠与、借款等）、金额、交付事实以及存在撤销赠与或返还的理由等。\n综上所述，恋爱期间的财产给与通常被视为自愿赠与，一旦赠与完成且不存在法定撤销情形，受赠人有权保有赠与物。对于可能存在争议的给与行为，建议双方在交往过程中明确约定性质，保留相关证据，以便在关系结束后依法处理财产问题。如发生纠纷，必要时可寻求法律专业人士的帮助。\n',
                    },
                ]}
            />
            <div className={styles.item}>
                <i>3</i>
                <div className={styles.desc}>更流畅</div>
                <b>对比段落:</b>
                <div className={styles.detail}>【讲解冲出恋爱迷雾的意义】</div>
            </div>
            <Table
                pagination={false}
                columns={UltraDialogTableColumns}
                dataSource={[
                    {
                        key: '1',
                        normal: '“冲出恋爱迷雾”的意义在于自我反思与理智抉择的勇气。它提醒我们在情感的纷扰中保持清醒，聆听内心深处的声音，评估这份感情是否促进个人成长，是否带来真正的幸福。这迷雾象征着困惑与依赖，而冲出它，就是敢于面对现实，理性分析关系，理解自己和伴侣的需求。这是一个痛苦但必要的过程，促使我们不断成长，寻找那个能让我们内心安定、不再迷失的爱情归宿。只有如此，我们才能在爱情的道路上行得更远，更坚定。',
                        ultra: '冲出恋爱迷雾，不仅代表着个体从情感纷扰中实现自我觉醒与成长，学会以理性驾驭情感，坚守个人价值观，寻求符合内心需求的恋爱关系，提升情感成熟度与生活智慧；更意味着建立起基于深度理解、真诚尊重与有效沟通的健康恋爱模式，双方能在平等互信的基础上共度人生起伏，共享喜悦，共渡困境，实现共同成长。此外，它强调个体即使身陷恋情，仍应保持精神与经济独立，坚持个人兴趣、事业与社交圈子，避免过度依赖，为彼此留有适当的空间，让爱在适度的距离中得以自由呼吸，愈发醇厚。冲出恋爱迷雾，实质上是在找寻和构筑一种清晰、健康、平衡且持久的爱情生活方式，让恋爱成为滋养心灵、丰富人生、促进个人与双方和谐发展的积极力量。',
                    },
                ]}
            />
        </Modal>
    );
});
